export const CHURNING_API_PATH = {
  LIST: "/v1/passenger-booking-list/",
};

export interface ChurningQueryPayload {
  passenger_name: string;
  flight_number?: string;
  departure_date?: string;
}
